import React, { useContext, useEffect, useRef, useState } from "react";
import More from "../../../../components/SVGComponents/Tools/More";
import { DROPDOWNTOOLS } from "../../../../constants/Constants";
import DropDownToolElement from "./DropDownToolElement";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import { ArrowAnnotateTool } from "@cornerstonejs/tools";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import AnnotationContext from "../../../../context/annotation/AnnotationContext";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";

const ToolDropDown = () => {
  const [showDropDown, setShowDropDown] = useState(false);
  const { studyModality } = useContext(studyviewerContext);
  const { activeModality } = useContext(ThumbnailContext);
  const { showKeyImagesAndTextAnnotation } = useContext(studyReportContext);
  const {isChildStudyActive} = useContext(ViewportContext);
  const [delayHandler, setDelayHandler] = useState(null);
  const dropDownRef = useRef(null);
  const handleDropDownClick = (ev) => {
    setShowDropDown(!showDropDown);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setShowDropDown(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const hideContextMenu = () => {
    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowDropDown(false);
      }, 300)
    );
  };

  const onShowContextualMenu = (ev) => {
    ev.preventDefault(); // don't navigate

    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowDropDown(true);
      }, 300)
    );

  };

  useEffect(() => {
    clearTimeout(hideContextMenu);
  }, [showDropDown]);

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className="highlight-tool"  onClick={handleDropDownClick} onMouseEnter={onShowContextualMenu} onMouseLeave={hideContextMenu}>
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}
          >
            <More />
          </div>
        </div>
        <div
          ref={dropDownRef}
          onMouseEnter={onShowContextualMenu} onMouseLeave={hideContextMenu}
          className="viewer-tool-more-dropdown  viewer-tool-more-dropdown-height react-scroll"
          style={{
            display: `${showDropDown ? "flex" : "none"}`,
            flexDirection: "column",
            position: "absolute",
            top: window.innerHeight * 0.075,
            zIndex: "9999",
            // backgroundColor: "#201F1E",
            
            boxShadow:
              "0px 0.6px 1.8px rgba(0, 0, 0, 0.1), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)",
            borderRadius: "5px",
            paddingLeft: "10px",
            paddingRight: "20px",
          }}
        >
          {DROPDOWNTOOLS.map((tool, index) => {
            if (!tool.NotFor.includes(activeModality)) {
              if (tool.key === ArrowAnnotateTool.toolName) {
                if (showKeyImagesAndTextAnnotation && !isChildStudyActive) {
                  return (
                    <div key={`${tool}_${index}`}>
                      <DropDownToolElement
                        tool={tool}
                        setShowDropDown={setShowDropDown}
                      />
                    </div>
                  );
                }
              } else {
                return (
                  <div key={`${tool}_${index}`}>
                    <DropDownToolElement
                      tool={tool}
                      setShowDropDown={setShowDropDown}
                    />
                  </div>
                );
              }
            }
          })}
        </div>
      </div>
    </>
  );
};

export default ToolDropDown;
